import React from "react";
import ReactApexChart from "react-apexcharts";

const TrendLineChart = ({ title, data, xKey, yKey, yLabel }) => {

  const chartData = data.map(entry => ({
    x: entry[xKey],
    y: entry[yKey],
  }));

  const series = [
    {
      name: title,
      data: chartData,
    },
  ];

  const options = {
    chart: {
      type: 'line',
      height: 280,
      toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    colors:["var(--primary)","var(--secondary)"],
    stroke: {
      curve: 'smooth',
      width: 3,
      colors:["var(--primary)","var(--secondary)"]
    },
    grid: {
      show: true,
      borderColor: '#dadada',
    },
    xaxis: {
      type: "datetime",
      labels: {
        style: {
          colors: '#B5B5C3',
          fontSize: '12px',
          fontFamily: 'Poppins',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: '#B5B5C3',
          fontSize: '12px',
          fontFamily: 'Poppins',
        },
      },
      title: {
        text: yLabel,
        style: {
          color: '#B5B5C3',
          fontSize: '14px',
          fontWeight: 500,
        },
      },
    },
    tooltip: {
      x: { format: 'dd MMM yyyy' },
      y: {
        formatter: (val) => `${val} ${yLabel.toLowerCase()}`,
      },
    },
    markers: {
      size: 4,
      colors:["var(--primary)","var(--secondary)"],
      strokeColors: '#fff',
      strokeWidth: 2,
    },
  };

  return (
    <div className="card mb-4">
      <div className="card-header py-3 px-3 d-flex justify-content-between align-items-center">
        <h4 className="heading m-0">{title}</h4>
      </div>
      <div className="card-body">
        <ReactApexChart options={options} series={series} type="line" height={280} />
      </div>
    </div>
  );
};

export default TrendLineChart;
